import React from "react";
import TableToggleRow from "./table-toggle-row";

/**
 * Group of toggle rows representing a single category
 * (e.g., all Member options, all TDR options, etc.)
 */
const TableCategoryGroup = ({
  categoryName,
  options,
  selectedOption,
  onOptionSelect,
  defaultPrice,
  categoryKey,
}) => {
  if (!options || options.length === 0) {
    return null;
  }

  return (
    <>
      <tr className="category-header-row">
        <td colSpan="6" className="category-header">
          <strong>{categoryName}</strong>
        </td>
      </tr>
      {options.map((option, index) => {
        // Determine if this option is selected
        let isSelected = false;
        if (selectedOption) {
          if (categoryKey === "yom") {
            isSelected = selectedOption.year === option.year;
          } else if (categoryKey === "departureTime") {
            // For departure time, compare both label and type
            isSelected = selectedOption.label === option.label;
          } else if (categoryKey === "member") {
            isSelected = selectedOption.value === option.value;
          } else if (categoryKey === "tdr") {
            isSelected = selectedOption.tdrDays === option.tdrDays;
          } else if (categoryKey === "airportRadius") {
            isSelected = selectedOption.radius === option.radius;
          } else {
            isSelected = selectedOption.value === option.value;
          }
        }

        return (
          <TableToggleRow
            key={`${categoryKey}-${index}`}
            option={option}
            category={categoryKey}
            isSelected={isSelected}
            onSelect={onOptionSelect}
            defaultPrice={defaultPrice}
          />
        );
      })}
    </>
  );
};

export default TableCategoryGroup;

